import { Injectable } from '@angular/core';
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import { GoogleApiLoaderOptions } from '@consts/consts';
import { GoogleApiLibraries } from '@core/types/google-api-libraries.model';

@Injectable({ providedIn: 'root' })
export class GoogleApiLoaderService {

  private libs: Partial<GoogleApiLibraries> = {};

  constructor() {
    setOptions(GoogleApiLoaderOptions);
  }

  public async loadLibrary<Library extends keyof GoogleApiLibraries>(libraryName: Library): Promise<GoogleApiLibraries[Library]> {
    const existing: GoogleApiLibraries[Library] = this.libs[libraryName] as GoogleApiLibraries[Library];

    // EARLY CACHE RETURN
    if (existing) return Promise.resolve(existing);

    const library: GoogleApiLibraries[Library] = await importLibrary(libraryName)
      .catch((error: Error) => {
        console.warn('[GoogleApiLoaderService] Load library error: ', error);

        return Promise.reject(error);
      });

    this.libs[libraryName] = library;

    return library;
  }

}
